export default "__VITE_ASSET__Dk0i9Pks__"